import React, { useContext } from "react";
import { GreenMachineContext } from "../../GreenMachineContext";
import { useLazyLoadQuery, graphql } from "react-relay";
import { GET_STACKS_FOR_SESSION } from "../index";

const GET_BUILD_RULES_FOR_SESSION = graphql`
  query GlobalRulesListQuery($greenMachineSessionID: ID!) {
    buildRulesForGreenMachineSession(
      greenMachineSessionId: $greenMachineSessionID
    ) {
      selectedBuildRules {
        id
        name
      }

      unselectedBuildRules {
        id
        name
      }
    }
  }
`;

export default function GlobalRulesList(props) {
  const { greenMachineSessionID } = useContext(GreenMachineContext);

  const rulesData = useLazyLoadQuery(GET_BUILD_RULES_FOR_SESSION, {
    greenMachineSessionID: greenMachineSessionID,
  });

  return (
    <div className="gm-rules-select-global">
      {rulesData &&
      rulesData.buildRulesForGreenMachineSession &&
      (rulesData.buildRulesForGreenMachineSession.selectedBuildRules.length >
        0 ||
        rulesData.buildRulesForGreenMachineSession.unselectedBuildRules.length >
          0) ? (
        <div>
          <h3>Global Rules</h3>
          {rulesData.buildRulesForGreenMachineSession.selectedBuildRules.map(
            (buildRule) => {
              return (
                <label key={buildRule.id}>
                  <input
                    type="checkbox"
                    checked={
                      buildRule.id in props.globalRuleChanges
                        ? props.globalRuleChanges[buildRule.id]
                        : true
                    }
                    onChange={(e) => {
                      props.updateGlobalRuleSelections(
                        buildRule.id,
                        e.target.checked
                      );
                    }}
                  />{" "}
                  {buildRule.name}
                </label>
              );
            }
          )}
          {rulesData.buildRulesForGreenMachineSession.unselectedBuildRules.map(
            (buildRule) => {
              return (
                <label key={buildRule.id}>
                  <input
                    type="checkbox"
                    checked={
                      buildRule.id in props.globalRuleChanges
                        ? props.globalRuleChanges[buildRule.id]
                        : false
                    }
                    onChange={(e) => {
                      props.updateGlobalRuleSelections(
                        buildRule.id,
                        e.target.checked
                      );
                    }}
                  />{" "}
                  {buildRule.name}
                </label>
              );
            }
          )}
          <hr />
        </div>
      ) : null}
    </div>
  );
}
